import React from "react";
import FrontEndHeader from "./header";

import '../../assets/FrontEnd/css/font.css';
import '../../assets/FrontEnd/plugins/bootstrap/css/bootstrap.min.css';
import '../../assets/FrontEnd/css/font-awesome/font-awesome.min.css';
import '../../assets/FrontEnd/css/magnific-popup.min.css';
import '../../assets/FrontEnd/plugins/owlcarousel/owl.carousel.min.css';
import '../../assets/FrontEnd/plugins/owlcarousel/owl.theme.default.min.css';
import '../../assets/FrontEnd/css/style.css';
import '../../assets/FrontEnd/js/toaster/toastr.min.css';
import '../../assets/FrontEnd/css/fancybox/fancybox-v4-0-27.css';

const FrontEndLayout = ({ children }) => {
  return (
    <main id="main-content">
        <div className="wrapper">
          <div className="main-wrapper">
            <FrontEndHeader></FrontEndHeader>
            {children}
          </div>
        </div>
    </main>
  );
};

export default FrontEndLayout;
